import { useSearchParams } from "react-router-dom";

export interface BuildSearchParams {
  /**
   * The UUID of the step to show in the step drawer.
   */
  stepUuid?: string | null;
  /**
   * The UUID of the job to show in the job drawer.
   */
  jobUuid?: string | null;
  /**
   * Indicates whether the step drawer should be open.
   */
  open?: string | null;
  /**
   * The active tab to display in the job drawer.
   */
  tab?: string | null;
  /**
   * The active sub-tab on the annotations page ("build" or "jobs").
   */
  annotationsTab?: string | null;
}

/**
 * Hook to extract build-page related query parameters from the URL.
 */
export default function useQueryParams(): BuildSearchParams {
  const [searchParams] = useSearchParams();
  const stepUuid = searchParams.get("sid");
  const jobUuid = searchParams.get("jid");
  const open = searchParams.get("open");
  const tab = searchParams.get("tab");
  const annotationsTab = searchParams.get("annotations_tab");

  return { stepUuid, jobUuid, open, tab, annotationsTab };
}
